import React, { useContext } from 'react';
import SearchContext from '../data/FunnelbackContext';
import styles from '../../css/functional.module.scss';

function DisplayMode() {
    const { userDisplayMode, setUserDisplayMode } = useContext(SearchContext);
    return (
        <div className={`${styles.displayMode} funnelback-instant-search-display-mode`}>
            <button
                type="button"
                className={userDisplayMode === 'grid' ? 'active' : ''}
                onClick={() => {
                    setUserDisplayMode('grid');
                }}
            >
                <svg>
                    <title>Card View</title>
                    <use href="#grid-view" />
                </svg>
            </button>
            <button
                type="button"
                className={userDisplayMode === 'list' ? 'active' : ''}
                onClick={() => {
                    setUserDisplayMode('list');
                }}
            >
                <svg>
                    <title>List View</title>
                    <use href="#list-view" />
                </svg>
            </button>
        </div>
    );
}

export default DisplayMode;
